/**
 * @generated SignedSource<<9669ce01905cb82dd29bfe087c349e53>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddAsanaProjectItemInput = {
  blockKey: string;
  clientMutationId?: string | null;
  id: string;
  name: string;
  noteId: string;
  projectType: string;
  title?: string | null;
};
export type AsanaIntegrationAddProjectItemMutation$variables = {
  input: AddAsanaProjectItemInput;
};
export type AsanaIntegrationAddProjectItemMutation$data = {
  readonly addAsanaProjectItem: {
    readonly asanaProject: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly asyncResultId: any | null;
  } | null;
};
export type AsanaIntegrationAddProjectItemMutation = {
  response: AsanaIntegrationAddProjectItemMutation$data;
  variables: AsanaIntegrationAddProjectItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddAsanaProjectItemPayload",
    "kind": "LinkedField",
    "name": "addAsanaProjectItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AsanaProjectNode",
        "kind": "LinkedField",
        "name": "asanaProject",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "asyncResultId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AsanaIntegrationAddProjectItemMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AsanaIntegrationAddProjectItemMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0cf9c7882e93dff8a4d37029c1b327ea",
    "id": null,
    "metadata": {},
    "name": "AsanaIntegrationAddProjectItemMutation",
    "operationKind": "mutation",
    "text": "mutation AsanaIntegrationAddProjectItemMutation(\n  $input: AddAsanaProjectItemInput!\n) {\n  addAsanaProjectItem(input: $input) {\n    asanaProject {\n      id\n      name\n    }\n    asyncResultId\n  }\n}\n"
  }
};
})();

(node as any).hash = "50ce2f816e633602727e9d55c2f05fef";

export default node;
